import Vue from 'vue'
import router from './router';
import BeansAdminPlugin from 'beans-admin-plugin';
import config from './admin-plugin-config';
import './theme.scss';
import './global.scss';
import { i18n } from './i18n';
import numeral from 'numeral';

Vue.config.productionTip = false;

Vue.use(BeansAdminPlugin, config);

Vue.component('money', {
  functional: true,
  render(h, { props: { value } }) {
    if (value) {
      return <span>{numeral(value).format('0,0.00')}</span>;
    }
    return <span>/</span>;
  }
});

Vue.component('percentage', {
  functional: true,
  render(h, { props: { value } }) {
    if (value) {
      return <span>{numeral(value).format('0.00%')}</span>;
    }
    return <span>/</span>;
  }
});

Vue.component('netValue', {
  functional: true,
  render(h, { props: { value } }) {
    if (value) {
      return <span>{numeral(value).format('0.0000')}</span>;
    }
    return <span>/</span>;
  }
});

const app = new Vue({
  router,
  i18n,
  template: '<router-view />'
}).$mount('#app')

export default app;
